<script>
    import DashboardItem    from './scripts/DashboardItem.svelte'
    import Header           from './scripts/Header.svelte'
    import Loader           from './scripts/Loader.svelte'

    // Variables
    let loading
    let loggedIn
    let missingUser
    let profile
    let userData
    let source

    // constants
    const searchUrl     = "https://eyztf8bhs0.execute-api.us-west-2.amazonaws.com/dev/learning-data"
    const inputAttrs    = {id: "source"}
    const sources       = [{value: "duo", label:  "Duolingo"},
                           {value: "khan", label: "Khan Academy"}]

    // functions
    const isReturn      = (keyCode) => keyCode === 13
    const submitSearch  = e => isReturn(e.keyCode) ? performSearch() : null

    const alertProfile  = () => alert("A username must be provided.")
    const hasProfile    = () => profile === "" ? alertProfile() : true

    const sourceIsSet   = () => !sources.some((e) => e.value === source)
    const alertSource   = () => alert("A source must be selected.")
    const hasSource     = () => sourceIsSet() ? alertSource() : true

    const getSearchData = (body, options) => {
        const receiveResponse = response => {
            if (!response.ok) {
                throw new Error(`Status code ${response.status}`)}
            return response.json()}

        const extractData = data => {
            if (data === undefined) {
                throw new Error('No data was returned.')}
            userData = data
            loading  = false}

        const handleError = error => {
            loading     = false
            missingUser = userData === undefined ? true : false}

        fetch(searchUrl, options)
            .then(receiveResponse)
            .then(extractData)
            .catch(handleError)}

    const performSearch = async () => {
        profile = document.getElementById("searchbar").value
        if (hasProfile() && hasSource()) {
            userData      = undefined
            loading       = true
            missingUser   = false
            const body    = {"profile": profile,
                             "source":  source}
            const options = {method: "POST",
                             body: JSON.stringify(body),
                             mode: "cors"}
            getSearchData(body, options)}}
</script>

<style>
    :root {
        --orange: #e16c24;
        --charcoal: #212121;
        --lightgrey: #787878;
        --white: #fefefe;
    }
    @font-face {
        font-family: 'existencelight';
        src: url('Existence-Light.woff2') format('woff2'),
             url('Existence-Light.woff')  format('woff');
    }
    @font-face {
        font-family: 'latolight';
        src: url('Lato-Light.woff2') format('woff2'),
             url('Lato-Light.woff')  format('woff');
    }
    :global(body) {
        background: var(--charcoal);
        font-family: 'existencelight';
        margin: 0;
        padding: 0;
    }
    main {
        margin-bottom: 3rem;
        height: 2000px;
    }
    div.dashboard {
        margin: 0 20% 5rem 20%;
    }
    div.search-container {
        color: var(--white);
        display: flex;
        flex-wrap: wrap;
        font-family: 'latolight';
        justify-content: center;
        margin: 5rem 20% 5rem 20%;
    }
    .search-container > #source {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: var(--lightgrey);
        border: 0;
        color: var(--white);
        flex: 1 1 8rem;
        width: 100%;
    }
    .search-container > #searchbar {
        flex: 1 1 20rem;
    }
    .search-container > #searchBtn {
        background: var(--orange);
        border: 0;
        color: var(--white);
        cursor: pointer;
        flex: 1 1 4rem;
    } 
</style>

<main>
    <Header loggedIn={loggedIn}/>
    <div class="search-container">
        <select id="source" bind:value={source}>
            <option>Select source...</option>
            {#each sources as s}
                <option value={s.value}>{s.label}</option>
            {/each}
        </select>
        <input type="text" id="searchbar" placeholder="Enter username..." on:keyup={submitSearch}>
        <button id="searchBtn" on:click={performSearch}><i class="fas fa-search"></i></button>
    </div>
    <div class="dashboard">
        {#if userData !== undefined}
            <DashboardItem {...userData} />
        {:else if loading === true}
            <Loader />
        {:else if missingUser === true}
            <h2>No data was found for username "{profile}".</h2>
        {/if}
    </div>
</main>
